import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { Helmet } from "react-helmet";
import ServiceInclude from "../../component/ServiceInclude";


const FinencialServiceCloud = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet prioritizeSeoTags={true}>
  <meta httpEquiv="content-type" content="text/html; charset=utf-8" />
  <meta name="format-detection" content="telephone=no" />
  <title>Top Salesforce Financial Cloud Consultant</title>
  <meta name="viewport" content="width=device-width, initial-scale=1" />

  <meta
    name="description"
    content="Codezix provides Salesforce Financial Services Cloud consulting and implementation to help banks, insurance companies, and wealth managers deliver personalised client experiences, streamline operations, and comply with regulations."
  />
  <meta
    name="keywords"
    content="Salesforce Financial Services Cloud, Financial Services Cloud consultant, banking CRM, insurance CRM, wealth management Salesforce, Salesforce FSL, financial services CRM implementation"
  />

  {/* BreadcrumbList */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://codezix.com/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Salesforce Financial Service Cloud",
      "item": "https://www.codezix.com/salesforce/finencial-service-cloud"
    }
  ]
}
    `}
  </script>

  {/* Organization */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://codezix.com/#organization",
  "name": "Codezix",
  "legalName": "Codezix Solutions",
  "url": "https://codezix.com/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://codezix.com/assets/images/logo.webp",
    "width": 250,
    "height": 80
  },
  "image": "https://codezix.com/assets/images/logo.webp",
  "description": "Codezix is a global Salesforce consulting and cloud solution provider helping enterprises across industries accelerate digital transformation.",
  "email": "info@codezix.com",
  "telephone": "+1-917-730-7436",
  "sameAs": [
    "https://www.linkedin.com/company/codezix",
    "https://www.facebook.com/codezix",
    "https://twitter.com/codezix"
  ]
}
    `}
  </script>

  {/* WebSite */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://codezix.com/#website",
  "url": "https://codezix.com/",
  "name": "Codezix",
  "publisher": {
    "@id": "https://codezix.com/#organization"
  }
}
    `}
  </script>

  {/* WebPage */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://www.codezix.com/salesforce/finencial-service-cloud#webpage",
  "url": "https://www.codezix.com/salesforce/finencial-service-cloud",
  "name": "Top Salesforce Financial Cloud Consultant",
  "inLanguage": "en-US",
  "description": "Codezix provides Salesforce Financial Services Cloud consulting and implementation to help banks, insurance firms, and wealth managers deliver personalised client experiences and operational excellence.",
  "isPartOf": {
    "@id": "https://codezix.com/#website"
  }
}
    `}
  </script>

  {/* Service */}
  <script type="application/ld+json">
    {`
{
  "@context": "https://schema.org",
  "@type": "Service",
  "@id": "https://www.codezix.com/salesforce/finencial-service-cloud#service",
  "url": "https://www.codezix.com/salesforce/finencial-service-cloud",
  "serviceType": "Salesforce Financial Services Cloud Consulting & Implementation",
  "name": "Salesforce Financial Services Cloud Consulting",
  "description": "Financial Services Cloud implementations by Codezix for banking, insurance, and wealth management — client 360, KYC/compliance, relationship management, advisory workflows, and outcome-driven dashboards.",
  "provider": {
    "@type": "Organization",
    "@id": "https://codezix.com/#organization"
  },
  "areaServed": {
    "@type": "City",
    "name": "Global"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Financial Services Cloud Offerings",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Banking & Retail Banking CRM"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Insurance Policy & Claims Management"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Wealth & Advisory Management Solutions"
        }
      }
    ]
  }
}
    `}
  </script>
</Helmet>


            <div className="service-banner top bottom">
                <div className="container">
                    <div className='explore-heading'>
                        <h2>Salesforce Financial Service Cloud</h2>
                    </div>
                    <div className="service-img mt-4">
                        <img src={require('../../assets/images/salesforce/Financial-cloud.webp')} alt="" />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <ServiceInclude />
                    </div>

                    <div className="col-lg-9">
                        <div className="salesforce-service">
                            <p className="prose-lg wow fadeUp">Salesforce Financial Services Cloud is designed to meet the unique needs of financial service providers, including retail and commercial banks, credit unions, private lenders, investment firms, insurance companies, wealth and asset management firms, and mortgage lenders. The platform includes all the features of Sales Cloud and Service Cloud, along with industry-specific tools, data models, processes, and capabilities tailored to the financial services sector.</p>
                        </div>

                        <div className="salesforce-services mt-4">
                            <div className='explore-heading text-left'>
                                <h2>Benefits of Financial Service Cloud</h2>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Savvy-arrangements.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">AI-Powered Scoring and Routing System</h3>
                                            <p className="wow fadeUp prose-lg">The Financial Services Cloud and routing system is powered by artificial intelligence (AI), enabling financial services to automatically score and route leads and opportunities to the appropriate agents. The system also provides real-time guidance to agents on the best actions to take in order to close deals successfully.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/On-request%20Adaptable%20arrangements.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp"> Improved Customer Service</h3>
                                            <p className="wow fadeUp prose-lg"> Another key advantage of Financial Services Cloud is enhanced customer support. It enables financial services to provide clients with a comprehensive view of their relationship with the organization. This holistic perspective includes financial data, account balances, transaction history, and more, allowing for better-informed decisions and stronger client relationships.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Key%20Decision%20Making2.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Expanded Productivity</h3>
                                            <p className="wow fadeUp prose-lg"> Financial Service Cloud likewise assists monetary administration associations with expanding their proficiency. Financial Service Cloud accompanies includes that mechanized errands and cycles. For instance, Financial Service Cloud can naturally make monetary reports, send account proclamations to clients, and cycle client installments. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='service-include-right mt-5'>
                                <div className='row'>
                                    <div className='col-lg-2 col-md-2 col-sm-3'>
                                        <div className='service-section-left-img'>
                                            <img src='https://d1087d7tlbvhw9.cloudfront.net/winklixi/winklixwebsite/salesforce-images/Proactive%20Salesforce%20specialists%20for%20your%20help.webp' alt='' />
                                        </div>
                                    </div>
                                    <div className='col-lg-10 col-md-10 col-sm-9'>
                                        <div className='service-section-right'>
                                            <h3 className="wow fadeUp">Informed Choices Utilizing CRM Investigation</h3>
                                            <p className="wow fadeUp prose-lg"> With Financial Service Cloud, clients can get client information from different sources and use it to come to informed conclusions about their business. Financial Service Cloud additionally permits clients to make custom reports and dashboards to assist them with keeping tabs on their development and arriving at better conclusions about their business. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='explore-heading text-left'>
                                <h2>Salesforce Financial Service Cloud Implementation</h2>
                                <p className="wow fadeUp prose-lg text-left">Salesforce Financial Services Cloud places the client at the center of business by automatically tracking data on client journeys and policies. Financial advisors can build strong relationships with clients by working seamlessly across multiple organizations. A comprehensive view of a client's financial profile allows advisors to provide personalized services that help clients achieve their life goals.</p>
                                <p className="wow fadeUp prose-lg text-left"> Financial Services Cloud is a wealth management CRM platform that enables clients to achieve their business objectives by managing investments, policies, insurance, property, accounts, and liabilities on a unified platform. Powerful productivity tools assist financial advisors in connecting with their clients and providing proactive, goal-oriented solutions. Financial Services Cloud delivers personalized service across any channel to tailor client success stories.</p>
                            </div>
                        </div>


                        <div className='cloud-demo' >
                            <div className='explore-heading text-left'>
                                <h2>What does Codezix offer you as a Salesforce Financial Services Cloud Consultant?</h2>
                                <p className="wow fadeUp prose-lg text-left">Codezix brings in-depth expertise as a Salesforce Financial Services Cloud Consultant, offering a range of services designed to help your business meet its targets efficiently and effectively.</p>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Reports Management</h3>
                                        <p className="wow fadeUp prose-lg">
                                            In addition to its use by advisors, this tool is also designed for managers. You can access your mobile dashboard, view key performance indicators, and easily manage pipeline reports, sales opportunities, business performance, and overall advisor productivity.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-1.webp')} alt='' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Crusade Apparatuses </h3>
                                        <p className="wow fadeUp prose-lg">
                                            Through our detailed reports, our team of certified Salesforce experts will segment your clients based on their preferences and behaviors. This approach will help you target the right opportunities, bringing in more qualified leads with a higher return on investment. We will set up the campaigns for you and assist in sending personalized messages to your clients, ensuring effective communication and engagement.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-2.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Versatile Dashboards </h3>
                                        <p className="wow fadeUp prose-lg">
                                            Now, you can engage your clients in a more efficient and impactful way. Codezix understands the importance of maintaining a powerful dashboard and seamless integration. That’s why we bring the full strength of Salesforce Financial Service Cloud into a compact, tailored mobile application. This will provide you with all the essential details right on your mobile device, with real-time updates across all channels, ensuring you never miss anything. Additionally, you can directly address client requests from your mobile, making it easier to manage and respond to their needs on the go.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-3.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Activity Plans</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Migration plans allow financial services professionals to collaborate seamlessly across departments and timelines. Using these plans, teams can assign tasks to the right project owners and set clear deadlines for specific client responsibilities. With Activity Plans, we can efficiently create dashboards and reports to monitor progress, ensuring consistency and alignment across all efforts. This helps track the overall workflow and guarantees that nothing falls through the cracks, keeping everything on track and on schedule.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-4.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Business Banking Application</h3>
                                        <p className="wow fadeUp prose-lg">
                                            This feature empowers professionals to gain a comprehensive view of clients' financial and business reports, allowing them to focus on maintaining consistent relationships. Business and commercial lenders get a clear, consolidated overview of their accounts, records, and key opportunities on the updated summary pages, ensuring they stay informed and connected with their clients’ needs.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-5.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Salesforce Einstein Bots</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Salesforce Einstein Bots for Salesforce Financial Service Cloud empower retail banking clients to manage their tasks through self-service bots, such as reporting a lost check card or tracking account activities directly from the bank's mobile app or website. Einstein Bots effectively handle customer inquiries, addressing issues in real-time and redirecting more complex matters to the appropriate service representative at the right moment. This ensures a seamless experience for clients, eliminating the need for them to repeat details and providing smooth, efficient financial interactions.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-6.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Einstein Analytics</h3>
                                        <p className="wow fadeUp prose-lg">
                                            For Salesforce Financial Services Cloud, Einstein Analytics integrates advanced data integrations, intuitive development wizards, customizable dashboards, and sophisticated datasets to provide a wealth of industry-specific insights for both retail and commercial banking. This powerful tool enables financial institutions to make data-driven decisions, improve client experiences, and streamline operations, all while leveraging cutting-edge analytics to stay ahead in a competitive market.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-7.webp')} alt='' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3> Einstein Analytics</h3>
                                        <p className="wow fadeUp prose-lg">
                                            For Salesforce Financial Services Cloud, Einstein Analytics integrates advanced data integrations, intuitive development wizards, customizable dashboards, and sophisticated datasets to provide a wealth of industry-specific insights for both retail and commercial banking. This powerful tool enables financial institutions to make data-driven decisions, improve client experiences, and streamline operations, all while leveraging cutting-edge analytics to stay ahead in a competitive market.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-8.webp')} alt='' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Admittance to Client Information</h3>
                                        <p className="wow fadeUp prose-lg">
                                            At Codezix, we provide you with invaluable insights into your opportunities and clients by gathering data from core financial systems, strategic frameworks, client management systems, and other essential sources. We analyze the aspects that matter most to your clients, including their preferences, habits, and significant life events. This comprehensive understanding helps you gain a clearer perspective on their interests, allowing you to communicate with them more effectively. By leveraging this data, we ensure your clients feel valued and understood, fostering stronger relationships and long-term loyalty.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-9.webp')} alt='' />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Sort All Client Information</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Sometimes, data can feel overwhelming. However, at Codezix, our experts will help you organize all your data and present it back to you in a structured way that makes it easy to access. This is particularly valuable when your team is interacting with clients, as they can view the most relevant information in real-time, allowing them to impress clients with insightful, personalized data that truly matters to them.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-10.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Client Division</h3>
                                        <p className="wow fadeUp prose-lg">
                                            With a diverse client base, it's essential to tailor your interactions to meet the unique needs of each client. At Codezix, we will help you segment your book of business into more manageable parts, allowing you to focus on what's most relevant to each client. This will enable you to engage in meaningful conversations, addressing the specific needs and requirements of each client in a more personalized and efficient way.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-11.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>TurboCharge Relationship Directors</h3>
                                        <p className="wow fadeUp prose-lg">
                                            In addition to managing individual clients, it's crucial to consider the broader organization. Often, a relationship manager or representative spends significant time organizing, compiling, and managing client data, which can hinder their focus on critical tasks and high-priority opportunities. At Codezix, we help streamline this process, allowing your team to focus on essential business activities while ensuring efficient data management and accessibility. This approach enables your organization to stay agile and responsive to both client needs and strategic goals.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-12.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Commitment Dashboards</h3>
                                        <p className="wow fadeUp prose-lg">
                                            At Codezix, our team will help uncover all your responsibilities within your organization and with your clients. You'll gain the ability to identify all potential opportunities to proactively engage with your clients. You'll know when and why to meet with them, along with key insights such as a list of clients you haven't interacted with in the past two months, those approaching retirement, upcoming birthdays, and much more. This data empowers you to stay ahead, build stronger relationships, and provide personalized service that truly resonates with your clients.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-13.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Lightning Schedulers</h3>
                                        <p className="wow fadeUp prose-lg">
                                            It enables seamless interaction between managers and clients to schedule appointments that are fully integrated into Salesforce workflows. Additionally, client relationship managers will have access to detailed plan files, providing a comprehensive view that ensures a more successful and satisfying financial experience moving forward.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-14.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>New Lightning-Empowered Arrangements</h3>
                                        <p className="wow fadeUp prose-lg">
                                            Our certified Financial Service Cloud experts have recognized the challenges posed by siloed data systems. With the updated and advanced features of Financial Service Cloud, we provide a 360-degree view of clients, enabling the delivery of exceptional and personalized client experiences throughout the entire client lifecycle across the business lines of the organization.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-15.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="implementation">
                                        <h3>Salesforce Studies</h3>
                                        <p className="wow fadeUp prose-lg">
                                            It allows you to quickly develop well-rounded and accurate insights for your clients, which can be viewed within their profile. These insights can be compiled into reports and dashboards that can be shared internally across the Salesforce Financial Service Cloud, ensuring seamless client analysis and collaboration.
                                        </p>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="implementation-img">
                                        <img src={require('../../assets/images/salesforce/finencial/finencial-16.webp')} alt='' />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="why-winklix">
                            <div className='explore-heading text-left'>
                                <h2>What are the Benefits of Choosing Codezix as a Salesforce Financial Service Cloud Partner?</h2>
                                <p className="prose-lg text-left">Benefits of Choosing Codezix as a Salesforce Financial Service Cloud Company are:</p>
                            </div>
                            <div className="row bottom">
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg">Flexible Management Models</li>
                                            <li className="wow fadeUp prose-lg"> 24x7 Support Across all Timezones</li>
                                            <li className="wow fadeUp prose-lg"> Competitive Prices and Ontime Delivery</li>
                                            <li className="wow fadeUp prose-lg"> State-of-the-art IT Infrastructure</li>
                                            <li className="wow fadeUp prose-lg"> Strone Technology Competence</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="why-listing mt-4">
                                        <ul>
                                            <li className="wow fadeUp prose-lg"> Seamless Communication</li>
                                            <li className="wow fadeUp prose-lg"> Years of Expertise</li>
                                            <li className="wow fadeUp prose-lg"> 1800+ Customers</li>
                                            <li className="wow fadeUp prose-lg">Salesforce Partner </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default FinencialServiceCloud;